import React, { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import { color, image } from "../../../resource";
import {
  Alert,
  Avatar,
  Badge,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Spin,
  Steps,
  Table,
  Tag,
} from "antd";
import "../FlashSaleClass.css";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import { AddProductContainer } from "../../ProductQuota/StyleProductQuota";
import Button from "../../../components/Button/Button";
import {
  ArrowRightOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useEffectOnce } from "react-use";
import {
  getProductCategory,
  getProductGroup,
  getProductList,
} from "../../../datasource/ProductDatasource";
import Select from "../../../components/Select/Select";
import { numberFormatter } from "../../../utility/Formatter";
import { LOCATION_FULLNAME_MAPPING } from "../../../definitions/location";
import dayjs from "dayjs";
import { FixedType } from "rc-table/lib/interface";
import { onInputNumberKeyPress } from "../../../utility/validator";
import { getShopGroup } from "../../../datasource/ShopGroupDatasoure";
import { getZones } from "../../../datasource/CustomerDatasource";
import {
  createStepFour,
  deleteProductFlashSale,
  getFlashSaleProductByRound,
  getFlashSaleRoundBadge,
  getFlashSaleShopQuotaByRound,
} from "../../../datasource/FlashSaleDatasource";

export const FlashSaleStepFour: React.FC<{
  form: any;
  company: any;
  setValidateStepFour?: any;
}> = ({ form, company, setValidateStepFour }) => {
  const flashSaleId = form.getFieldsValue(true).flashSaleId;
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [current, setCurrent] = useState(0);
  const [loadingRound, setLoadingRound] = useState(false);
  const [openModalProd, setOpenModalProd] = useState(false);
  const [strategyGroupList, setStrategyGroupList] = useState<any[]>([]);
  const [prodGroupList, setProdGroupList] = useState<any[]>([]);
  const [openModalSetting, setOpenModalSetting] = useState<{
    open: boolean;
    roundNo: number;
    dataProduct: any;
    typeSetting: "product" | "all";
  }>({
    open: false,
    roundNo: 0,
    dataProduct: undefined,
    typeSetting: "product",
  });
  const [showMessage, setShowMessage] = useState(false);
  const watchRound = Form.useWatch("rounds", form);
  const [trackStep, setTrackStep] = useState<boolean[]>([]);
  const [validateNavigate, setValidateNavigate] = useState<boolean>(true);
  const [validateSubmitRound, setValidateSubmitRound] = useState(false);
  const [searchSection, setSearchSection] = useState<any>({
    text: undefined,
    strategy: undefined,
    prodGroup: undefined,
  });

  const watchCurrentRound = Form.useWatch(["rounds", current, "products"], form);
  const watchCurrentSearchRound = Form.useWatch(["rounds", current, "searchProducts"], form);
  const [modalDeleteShop, setModalDeleteShop] = useState(false);
  const [modalDuplicate, setModalDuplicate] = useState(false);

  const optionPrice = [
    { name: "แสดงราคาเต็ม", key: "FULL", value: "10,008.00฿", img: image.empty_sack },
    { name: "ไม่แสดงราคา", key: "HIDE_ALL", value: "XX,XXX.XX฿", img: image.empty_sack },
    { name: "แสดงราคาบางส่วน", key: "PARTIAL", value: "1X,XX8.XX฿", img: image.empty_sack },
    {
      name: "สินค้าเซอร์ไพรส์",
      key: "SURPRISE",
      value: "",
      img: image.red_curtain,
    },
  ];

  const fetchCatetory = async () => {
    const getCatetory = await getProductCategory(company).then((res) => {
      return res;
    });
    setStrategyGroupList(getCatetory);
  };
  const fetchProdGroup = async () => {
    const getProdGroup = await getProductGroup(company).then((res) => {
      return res.responseData;
    });
    setProdGroupList(getProdGroup);
  };

  useEffectOnce(() => {
    fetchCatetory();
    fetchProdGroup();
  });

  const fetchFlashSaleProductByRound = async (flashSaleRoundId: string, roundNo: number) => {
    setLoadingRound(true);
    try {
      const checkBadge = await getFlashSaleRoundBadge({ flashSaleId });
      const response = await getFlashSaleProductByRound({
        flashSaleRoundId,
      });
      const products = response?.data || [];
      setTrackStep((prevTrackStep) => {
        const mapData =
          products.length > 0
            ? checkBadge?.find((item: any) => item.roundNo === roundNo)?.isBadge
              ? false
              : true
            : false;
        const updatedTrackStep = [...prevTrackStep];
        updatedTrackStep[roundNo - 1] = mapData;
        return updatedTrackStep;
      });
      const mapData = await Promise.all(
        products.map(async (shopProduct: any) => {
          const quota = await getFlashSaleShopQuotaByRound(shopProduct.flashSaleRoundProductId);
          return {
            ...shopProduct,
            discount: shopProduct.discount === 0 ? undefined : shopProduct.discount,
            productCodeNAV: shopProduct.productCodeNAV || shopProduct.productCode,
            saleUOM: shopProduct.saleUOM || shopProduct.saleUom,
            saleUOMTH: shopProduct.saleUOMTH || shopProduct.saleUomTh,
            baseUOM: shopProduct.baseUOM || shopProduct.baseUom,
            isSetting: true,
            shopQuotas: quota?.shopQuotas?.length > 0 ? quota.shopQuotas : [],
            isEdit: false,
            isNonQuota: shopProduct.nonQuota || false,
          };
        }),
      );
      setTimeout(() => {
        setLoadingRound(false);
      }, 300);
      return mapData;
    } catch (error) {
      console.error("fetchFlashSaleProductByRound error:", error);
      return [];
    }
  };

  useEffect(() => {
    if (form.getFieldValue("rounds")?.length > 0) {
      form.getFieldValue("rounds").map(async (round: any) => {
        const response: any = await fetchFlashSaleProductByRound(
          round.flashSaleRoundId,
          round.roundNo,
        );
        form.setFieldsValue({
          ...form.getFieldsValue(true),
          rounds: form
            .getFieldValue("rounds")
            .map((r: any) =>
              r.roundNo === round.roundNo
                ? { ...r, products: response, searchProducts: response }
                : r,
            ),
        });
      });
    }
  }, []);

  useEffect(() => {
    setValidateStepFour(!trackStep.every((step) => step));
  }, [trackStep]);

  const TimeSlot = ({ round, startDate, endDate, time }: any) => (
    <FlexCol
      style={{
        alignItems: "center",
        position: "relative",
      }}
      key={round}
    >
      {!trackStep[round - 1] && (
        <div
          style={{
            position: "absolute",
            top: -6,
            left: "80%",
            transform: "translateX(-50%)",
          }}
        >
          <Badge
            color={color.error}
            styles={{
              indicator: {
                width: 8,
                height: 8,
                minWidth: 8,
                borderRadius: "50%",
              },
            }}
          />
        </div>
      )}
      <Text level={5} fontWeight={600} color={round === current + 1 ? "primary" : "Text3"}>
        รอบที่ {round}
      </Text>
      <Text level={6} color={round === current + 1 ? "primary" : "Text3"}>
        {startDate} → {endDate}
      </Text>
      <Text level={6} color={round === current + 1 ? "primary" : "Text3"}>
        ({time})
      </Text>
    </FlexCol>
  );
  const items = form?.getFieldValue("rounds")?.map((i: any) => ({
    title: (
      <TimeSlot
        key={i.roundNo}
        round={i.roundNo}
        startDate={dayjs(i.startDate).format("DD/MM/YYYY")}
        endDate={dayjs(i.endDate).format("DD/MM/YYYY")}
        time={`${dayjs(i.startDate).format("HH:mm")}-${dayjs(i.endDate).format("HH:mm")}`}
      />
    ),
  }));

  const validateNavigateStep = (roundNo: number, tracks: any) => {
    const rounds: any = form.getFieldsValue(true)?.rounds || [];
    const currentRound = rounds?.find(
      ({ roundNo: currentRoundNo }: any) => `${currentRoundNo}` === `${roundNo}`,
    );
    const isValidEdit = currentRound?.products.filter((p: any) => p.isEdit) || [];
    const isValidNonQuota = currentRound?.products.filter((p: any) => p.isNonQuota) || [];
    const isValidSetting = currentRound?.products.filter((p: any) => p.isSetting) || [];

    setValidateNavigate(
      isValidEdit?.length < 1 &&
        isValidSetting?.length === currentRound?.products?.length &&
        isValidNonQuota?.length < 1,
    );
    setValidateSubmitRound(
      isValidEdit?.length > 0 &&
        isValidNonQuota?.length === 0 &&
        currentRound?.products.filter((p: any) => !p.isSetting)?.length < 1,
    );
    setValidateStepFour(!(tracks.filter((step) => step === true).length === rounds.length));
    // setShowMessage(
    //   currentProducts?.length > 0 || isValidSetting?.length > 0 || isValidNonQuota?.length > 0,
    // );
  };

  const onSearch = (text: string, strategy: string, prodGroup: string) => {
    const filteredData = form.getFieldValue(["rounds", current, "products"]).filter((item) => {
      const textSearch = text ? item.productName.toLowerCase().includes(text.toLowerCase()) : true;
      const strategySearch = strategy
        ? company === "ICPL"
          ? item.productStrategy.toLowerCase().includes(strategy.toLowerCase())
          : item.productCategoryId === strategy
        : true;
      const prodGroupSearch = prodGroup ? item.productGroup === prodGroup : true;
      return textSearch && strategySearch && prodGroupSearch;
    });
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      rounds: form
        .getFieldValue(["rounds"])
        .map((round: any, index: number) =>
          index === current ? { ...round, searchProducts: filteredData } : round,
        ),
    });
  };

  const onDelete = async () => {
    const updatedProducts = form
      .getFieldValue(["rounds", current, "products"])
      .filter((item: any) => !item.isChecked);

    const deleteProductIds = form
      .getFieldValue(["rounds", current, "products"])
      .filter((item: any) => item.isChecked)
      .map((item: any) => item.flashSaleRoundProductId)
      .filter((id: any) => id !== undefined && id !== null);

    if (deleteProductIds.length > 0) {
      await deleteProductFlashSale({
        flashSaleRoundProductIds: deleteProductIds,
        updateBy: profile?.firstname + " " + profile?.lastname,
      }).then((res) => {
        console.log("Delete response: ", res);
      });
    }

    form.setFieldsValue({
      ...form.getFieldsValue(true),
      rounds: form
        .getFieldValue(["rounds"])
        .map((round: any, index: number) =>
          index === current
            ? { ...round, products: updatedProducts, searchProducts: updatedProducts }
            : round,
        ),
    });
    onSearch(searchSection.text, searchSection.strategy, searchSection.prodGroup);
    validateNavigateStep(current + 1, trackStep);
  };

  const columns = [
    {
      title: (
        <Checkbox
          checked={
            watchCurrentSearchRound?.length > 0 &&
            watchCurrentSearchRound?.every((x) => x.isChecked)
          }
          onClick={(e: any) => {
            const checked = e.target.checked;
            const updatedProducts = form
              .getFieldValue(["rounds", current, "products"])
              .map((item: any) => ({ ...item, isChecked: checked }));
            form.setFieldsValue({
              ...form.getFieldsValue(true),
              rounds: form
                .getFieldValue(["rounds"])
                .map((round: any, index: number) =>
                  index === current
                    ? { ...round, products: updatedProducts, searchProducts: updatedProducts }
                    : round,
                ),
            });
            onSearch(searchSection.text, searchSection.strategy, searchSection.prodGroup);
          }}
        />
      ),
      width: "3%",
      render: (text: string, value: any) => (
        <Checkbox
          checked={value.isChecked}
          onClick={(e: any) => {
            const checked = e.target.checked;
            const updatedProducts = form
              .getFieldValue(["rounds", current, "products"])
              .map((item: any) =>
                item.productId === value.productId ? { ...item, isChecked: checked } : item,
              );
            form.setFieldsValue({
              ...form.getFieldsValue(true),
              rounds: form
                .getFieldValue(["rounds"])
                .map((round: any, index: number) =>
                  index === current
                    ? { ...round, products: updatedProducts, searchProducts: updatedProducts }
                    : round,
                ),
            });
            onSearch(searchSection.text, searchSection.strategy, searchSection.prodGroup);
          }}
        />
      ),
    },
    {
      title: <span>ชื่อสินค้า</span>,
      dataIndex: "productName",
      width: "22%",
      render: (text: string, value: any, index: any) => (
        <FlexRow align='center'>
          <div style={{ marginRight: 16 }}>
            <Avatar
              src={
                value.productImage === "No" ||
                value.productImage === "" ||
                value.productImage === null
                  ? image.product_no_image
                  : value.productImage
              }
              size={50}
              shape='square'
              onError={() => false}
            />
          </div>
          <FlexCol>
            <div style={{ height: 25, textOverflow: "ellipsis" }}>
              <Text level={5}>{value.productName}</Text>
            </div>
            {value.commonName && (
              <div style={{ height: 25, textOverflow: "ellipsis" }}>
                <Text level={6} style={{ color: color.Grey }}>
                  {value.commonName}
                </Text>
              </div>
            )}
            <div style={{ height: 25 }}>
              <Text level={6} style={{ color: color.Grey }}>
                Product Group : {value.productGroup}
              </Text>
            </div>
            {value.productStrategy && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Strategy Group : {value.productStrategy}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>ขนาด</span>,
      dataIndex: "productCodeNAV",
      width: "12%",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25 }}>
              <Text level={5}>{text}</Text>
            </div>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={6} style={{ color: color.Grey }}>
                Pack Size : {value.packSize}
              </Text>
            </div>
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>ราคาขาย</span>,
      dataIndex: "unitPrice",
      width: "10%",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={5}>
                {numberFormatter(value.marketPrice)} บาท/{value.saleUOMTH}
              </Text>
            </div>
            {company === "ICPL" && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  ราคา/หน่วย : {numberFormatter(text)} บาท/{value.baseUOM}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>โปรโมชัน</span>,
      dataIndex: "promotion",
      width: "10%",
      render: (text: string, value: any) => (
        <>
          {value?.promotionType !== "NONE" && value?.promotionType !== undefined ? (
            <FlexCol>
              <Text>ส่วนลด</Text>
              <Text>
                {value.promotionType.includes("BAHT")
                  ? `${numberFormatter(value.discount, 2)} บาท`
                  : `${value.discount}%`}{" "}
                / {value.saleUOMTH}
              </Text>
              <Text color='success'>
                {value.promotionType.includes("BAHT")
                  ? numberFormatter(value.marketPrice - value.discount, 2) + " บาท"
                  : `${numberFormatter(value.marketPrice - value.marketPrice * (value.discount / 100), 2)} บาท`}
                / {value.saleUOMTH}
              </Text>
            </FlexCol>
          ) : value?.promotionType === "NONE" ? (
            <Text>-</Text>
          ) : (
            <FlexCol>
              <Text level={5}>ยังไม่ได้ระบุ</Text>
              {showMessage && !value.isSetting && (
                <Text level={6} color='error'>
                  กรุณาตั้งค่า
                </Text>
              )}
            </FlexCol>
          )}
        </>
      ),
    },
    {
      title: <span>โควตา</span>,
      dataIndex: "quota",
      width: "10%",
      render: (text: string, value: any) => (
        <>
          {value?.quotaType === "QUOTA_TOTAL" ? (
            <FlexCol>
              <Text>โควตารวม</Text>
              <Text>
                {numberFormatter(value.quotaTotal, 0)} {value.saleUOMTH}
              </Text>
            </FlexCol>
          ) : value?.quotaType === "QUOTA_INDIVIDUAL" ? (
            <FlexCol>
              <Text>โควตารายร้าน</Text>
              <Text color='Text3' level={6}>
                {(() => {
                  const quota =
                    value.shopQuotas.length > 0 &&
                    value.shopQuotas.every(
                      (item) => Number(item.quota) === Number(value.shopQuotas[0].quota),
                    )
                      ? Number(value.shopQuotas[0].quota)
                      : null;
                  return quota !== null
                    ? `${numberFormatter(quota, 0)} ${value.saleUOMTH} (เท่ากันทุกร้าน)`
                    : "แต่ละร้านไม่เท่ากัน";
                })()}
              </Text>
            </FlexCol>
          ) : value?.quotaType === "QUOTA_NONE" ? (
            <FlexCol>
              <Text>-</Text>
            </FlexCol>
          ) : (
            <FlexCol>
              <Text>ยังไม่ได้ระบุ</Text>
              {showMessage && !value.isSetting && (
                <Text level={6} color='error'>
                  กรุณาตั้งค่า
                </Text>
              )}
            </FlexCol>
          )}
        </>
      ),
    },
    {
      title: <span>แสดงราคา,สินค้า</span>,
      dataIndex: "displayPriceProduct",
      width: "10%",
      render: (text: string, value: any) => (
        <>
          {value?.priceDisplay ? (
            <FlexCol>
              <Text>{optionPrice?.find((option) => option.key === value.priceDisplay)?.name}</Text>
              <Text level={6} color='Text3'>
                {optionPrice?.find((option) => option.key === value.priceDisplay)?.value}
              </Text>
            </FlexCol>
          ) : (
            <FlexCol>
              <Text level={5}>ยังไม่ได้ระบุ</Text>
              {showMessage && !value.isSetting && (
                <Text level={6} color='error'>
                  กรุณาตั้งค่า
                </Text>
              )}
            </FlexCol>
          )}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "setting",
      fixed: "right" as FixedType | undefined,
      width: "8%",
      render: (text: string, value: any) => (
        <FlexCol>
          <Tag
            style={{
              cursor: "pointer",
              backgroundColor: "#FFFFFF",
              borderRadius: 4,
              borderColor: "#E5EAEE",
            }}
            onClick={() =>
              setOpenModalSetting({
                open: true,
                roundNo: current + 1,
                dataProduct: value,
                typeSetting: "product",
              })
            }
          >
            <Text color='primary'>
              <SettingOutlined /> ตั้งค่า
            </Text>
            {value?.isNonQuota && (
              <Badge
                color={color.error}
                styles={{
                  indicator: {
                    width: 10,
                    height: 10,
                    minWidth: 10,
                    borderRadius: "50%",
                  },
                }}
                style={{
                  position: "absolute",
                  top: -10,
                  left: "100%",
                  transform: "translateX(-50%)",
                }}
              />
            )}
          </Tag>
        </FlexCol>
      ),
    },
  ];

  return (
    <>
      <Form form={form} layout='vertical'>
        <Steps
          className='custom-navigation-steps'
          type='navigation'
          current={current}
          onChange={(value) => {
            onSearch("", "", "");
            setSearchSection({ text: "", strategy: "", prodGroup: "" });
            if (validateNavigate) {
              setLoadingRound(true);
              setCurrent(value);
              setTimeout(() => {
                setLoadingRound(false);
              }, 300);
            }
          }}
          items={items}
        />
        <br />
        {loadingRound ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            <div style={{ paddingBottom: "10px" }}>
              <span
                className='card-label font-weight-bolder text-dark'
                style={{ fontSize: 18, fontWeight: "bold" }}
              >
                สินค้าที่เข้าร่วม <b style={{ color: color.error }}>*</b>
              </span>
            </div>
            {form?.getFieldValue("rounds") &&
            form?.getFieldValue("rounds")?.find((r) => r.roundNo === current + 1)?.products
              ?.length > 0 ? (
              <>
                <Row justify='space-between' align='middle'>
                  <Col span={20}>
                    <Row justify='start' gutter={8}>
                      <Col span={6}>
                        <Input
                          allowClear
                          placeholder='ค้นหาชื่อสินค้าหรือรหัสสินค้า...'
                          suffix={<SearchOutlined />}
                          style={{ width: "100%", height: 40 }}
                          onPressEnter={(e: any) => {
                            setSearchSection({ ...searchSection, text: e.target.value });
                            onSearch(
                              e.target.value,
                              searchSection.strategy,
                              searchSection.prodGroup,
                            );
                          }}
                          onChange={(e) => {
                            if (!e.target.value) {
                              onSearch("", searchSection.strategy, searchSection.prodGroup);
                            }
                            setSearchSection({ ...searchSection, text: e.target.value });
                          }}
                          value={searchSection.text}
                        />
                      </Col>
                      {company === "ICPL" && (
                        <Col span={4}>
                          <Select
                            data={[
                              {
                                key: "",
                                value: "",
                                label: "ทั้งหมด",
                              },
                              ...prodGroupList.map((p: any) => ({
                                key: p?.product_group,
                                value: p?.product_group,
                                label: p.product_group,
                              })),
                            ]}
                            onChange={(e) => {
                              setSearchSection({ ...searchSection, prodGroup: e });
                              onSearch(searchSection.text, searchSection.strategy, e);
                            }}
                            placeholder='Product Group'
                            style={{ width: "100%" }}
                            value={searchSection.prodGroup}
                          />
                        </Col>
                      )}
                      <Col span={4}>
                        <Select
                          data={[
                            {
                              key: "",
                              value: "",
                              label: "ทั้งหมด",
                            },
                            ...strategyGroupList.map((p: any) => ({
                              key: p.productCategoryId,
                              value: p.productCategoryId,
                              label: p.productCategoryName,
                            })),
                          ]}
                          onChange={(e) => {
                            setSearchSection({ ...searchSection, strategy: e });
                            onSearch(searchSection.text, e, searchSection.prodGroup);
                          }}
                          placeholder={company === "ICPL" ? "Strategy Group" : "Category Group"}
                          style={{ width: "100%" }}
                          value={searchSection.strategy}
                        />
                      </Col>
                      <Col span={3}>
                        <Button
                          title='ล้างการค้นหา'
                          typeButton='primary-light'
                          onClick={() => {
                            setSearchSection({ text: "", prodGroup: "", strategy: "" });
                            onSearch("", "", "");
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ paddingTop: "10px" }}>
                    <DeleteOutlined
                      onClick={() =>
                        watchCurrentRound?.some((shop: any) => shop.isChecked) &&
                        setModalDeleteShop(true)
                      }
                      style={{
                        fontSize: "20px",
                        color: watchCurrentRound?.some((shop: any) => shop.isChecked)
                          ? color.error
                          : color.Text3,
                        cursor: "pointer",
                      }}
                    />

                    {modalDeleteShop && (
                      <Modal
                        open={modalDeleteShop}
                        centered
                        closable={true}
                        maskClosable={false}
                        okText='บันทึก'
                        cancelText='ยกเลิก'
                        title={
                          <Text fontWeight={600} level={2}>
                            ลบรายการที่เลือก{" "}
                            {watchCurrentRound?.filter((shop: any) => shop.isChecked)?.length}{" "}
                            รายการ
                          </Text>
                        }
                        okButtonProps={{
                          style: { backgroundColor: color.error, borderColor: color.error },
                        }}
                        cancelButtonProps={{
                          style: { borderColor: color.error, color: color.error },
                        }}
                        width={500}
                        onOk={() => {
                          onDelete();
                          setModalDeleteShop(false);
                          // setValidateNavigate(true);
                        }}
                        onCancel={() => setModalDeleteShop(false)}
                      >
                        <Text color='Text3'>โปรดยืนยันการลบรายการ</Text>
                        <Divider size='small' />
                      </Modal>
                    )}
                  </Col>
                  <Col span={3}>
                    <Button
                      typeButton='primary'
                      title='+ เพิ่มสินค้า'
                      onClick={() => setOpenModalProd(true)}
                    />
                  </Col>
                </Row>
                <Row
                  justify='space-between'
                  align='middle'
                  style={{ paddingTop: 10, paddingBottom: 10 }}
                >
                  <Form.Item name={["rounds", current, "products"]} noStyle>
                    <Col span={3}>
                      <Button
                        typeButton={
                          watchCurrentRound?.some((p: any) => p.isChecked)
                            ? "primary-light"
                            : "border-light"
                        }
                        title='ตั้งค่าเงื่อนไขเดียวกัน'
                        onClick={() =>
                          watchCurrentRound?.some((p: any) => p.isChecked) &&
                          setOpenModalSetting({
                            open: true,
                            roundNo: current + 1,
                            dataProduct: undefined,
                            typeSetting: "all",
                          })
                        }
                      />
                    </Col>
                  </Form.Item>
                  <Col>
                    <Text>
                      จำนวนที่เลือก{" "}
                      {form.getFieldValue(["rounds", current, "searchProducts"])?.length || 0}{" "}
                      รายการ
                    </Text>
                  </Col>
                </Row>
                <Form.Item name={["rounds", current, "searchProducts"]}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerBg: "#EFF2F9",
                          headerColor: color.Text1,
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                        },
                      },
                    }}
                  >
                    <Table
                      columns={columns}
                      dataSource={form?.getFieldValue(["rounds", current, "searchProducts"]) || []}
                      pagination={false}
                      scroll={{ x: 1700, y: 500 }}
                    />
                  </ConfigProvider>
                </Form.Item>
              </>
            ) : (
              <>
                {form?.getFieldValue("rounds")?.some((r: any) => r.products?.length > 0) && (
                  <Row style={{ paddingBottom: 10 }} justify='start' gutter={8}>
                    <Col span={5}>
                      <Button
                        typeButton='primary-light'
                        title='ตั้งค่าสินค้าเดียวกันกับรอบอื่น'
                        onClick={() => setModalDuplicate(true)}
                      />
                    </Col>
                  </Row>
                )}
                <AddProductContainer onClick={() => setOpenModalProd(true)}>
                  <FlexCol justify='center' align='center'>
                    <img src={image.addProduct} height={120} />
                    <br />
                    <Text level={4} color='primary'>
                      + เพิ่มสินค้า
                    </Text>
                    <Text>โปรดเลือกสินค้าที่ต้องการ</Text>
                  </FlexCol>
                </AddProductContainer>
              </>
            )}
            <br />
          </>
        )}
        <Row justify='end'>
          <Col>
            <Button
              icon={<ArrowRightOutlined style={{ color: color.white }} />}
              iconPlacement='right'
              typeButton={validateSubmitRound ? "primary" : "disabled"}
              title={`ยืนยันรอบที่ ${current + 1}`}
              onClick={async () => {
                if (!validateSubmitRound) return;
                setLoadingRound(true);
                const dataFrom = form.getFieldsValue(true);
                const rounds = dataFrom?.rounds.find((r: any) => r.roundNo === current + 1) || [];
                const payload = {
                  flashSaleId: dataFrom?.flashSaleId,
                  flashSaleRoundId: rounds?.flashSaleRoundId,
                  updateBy: profile?.firstname + " " + profile?.lastname,
                  products: rounds.products.map((p: any) => ({
                    productId: p.productId,
                    productCode: p.productCodeNAV || p.productCode,
                    productName: p.productName,
                    productGroup: p.productGroup,
                    productStrategy: p.productStrategy,
                    productImage: p.productImage,
                    packSize: p.packSize,
                    saleUom: p.saleUOM || p.saleUom,
                    saleUomTh: p.saleUOMTH || p.saleUomTh,
                    baseUom: p.baseUOM || p.baseUom,
                    marketPrice: Number(p.marketPrice),
                    unitPrice: Number(p.unitPrice),
                    promotionType: p.promotionType,
                    discount: p.discount && Number(p.discount),
                    quotaType: p.quotaType,
                    quotaTotal: p.quotaTotal && Number(p.quotaTotal),
                    defaultQuotaPerShop: p.defaultQuotaPerShop && Number(p.defaultQuotaPerShop),
                    priceDisplay: p.priceDisplay,
                    shopQuotas: p.shopQuotas,
                    productCategoryName: p.productCategory?.productCategoryName,
                    productCategoryImage: p.productCategory?.productCategoryImage,
                    commonName: p.commonName,
                    description: p.description,
                    vat: Number(p.vat) || 0,
                  })),
                };
                await createStepFour(payload).then(async (res) => {
                  if (res.success) {
                    setTrackStep((prevTrackStep) => {
                      const updatedTrackStep = [...prevTrackStep];
                      updatedTrackStep[current] = true;
                      return updatedTrackStep;
                    });
                    await form.setFieldValue(
                      ["rounds", current, "searchProducts"],
                      form?.getFieldValue(["rounds", current, "products"]).map((p: any) => ({
                        ...p,
                        isEdit: false,
                        isNonQuota: false,
                        isSetting: true,
                      })) || [],
                    );
                    await form.setFieldValue(
                      ["rounds", current, "products"],
                      form?.getFieldValue(["rounds", current, "products"]).map((p: any) => ({
                        ...p,
                        isEdit: false,
                        isNonQuota: false,
                        isSetting: true,
                      })) || [],
                    );
                    await validateNavigateStep(res?.responseData?.roundNo, trackStep);
                  }
                });
                setTimeout(() => {
                  setLoadingRound(false);
                }, 300);
              }}
            />
          </Col>
        </Row>
      </Form>
      {openModalProd && (
        <ModalProductFlashSale
          open={openModalProd}
          onClose={() => setOpenModalProd(false)}
          form={form}
          company={company}
          onSubmit={(products: any) => {
            setShowMessage(false);
            const rounds: any = form.getFieldsValue(true)?.rounds || [];
            const newRounds: any = rounds?.map((round: any) => {
              const {
                roundNo: currentRoundNo,
                products: currentProducts = [],
                searchProducts: currentSearchProducts = [],
              } = round || {};

              if (currentRoundNo === current + 1) {
                return {
                  ...round,
                  products: [...currentProducts, ...products],
                  searchProducts: [...currentSearchProducts, ...products],
                };
              }
              return round;
            });
            let newTrackStep = [...trackStep];
            setTrackStep((prevTrackStep: boolean[]) => {
              newTrackStep = newTrackStep = [...prevTrackStep];
              newTrackStep[current] = false;
              return newTrackStep;
            });
            form.setFieldsValue({
              ...form.getFieldsValue(true),
              rounds: newRounds,
            });
            validateNavigateStep(current + 1, newTrackStep);
          }}
          strategyGroupList={strategyGroupList}
          prodGroupList={prodGroupList}
          roundNo={current + 1}
        />
      )}
      {openModalSetting.open && (
        <ModalSettingConditionProduct
          typeSetting={openModalSetting.typeSetting}
          open={openModalSetting.open}
          onClose={(key) => {
            if (key === "save") {
              validateNavigateStep(current + 1, trackStep);
            }
            setShowMessage(false);
            setOpenModalSetting({
              open: false,
              roundNo: current + 1,
              dataProduct: undefined,
              typeSetting: "product",
            });
          }}
          form={form}
          company={company}
          dataProduct={openModalSetting.dataProduct}
          roundNo={openModalSetting.roundNo}
          optionPrice={optionPrice}
        />
      )}
      {modalDuplicate && (
        <ModalDuplicateRound
          open={modalDuplicate}
          onClose={(key) => {
            if (key === "save") {
              validateNavigateStep(current + 1, trackStep);
            }
            setModalDuplicate(false);
          }}
          form={form}
          roundNo={current + 1}
        />
      )}
    </>
  );
};

const ModalProductFlashSale: React.FC<{
  open: boolean;
  onClose: () => void;
  form: any;
  company: any;
  onSubmit?: any;
  strategyGroupList: any[];
  prodGroupList: any[];
  roundNo: number;
}> = ({ open, onClose, form, company, onSubmit, strategyGroupList, prodGroupList, roundNo }) => {
  const [formProduct] = Form.useForm();
  const dataForm = form.getFieldsValue(true);
  const watchProductList = Form.useWatch("productSelect", formProduct);
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState<any>(undefined);
  const [searchStrategy, setSearchStrategy] = useState<any>(undefined);
  const [searchProdGroup, setSearchProdGroup] = useState<any>(undefined);

  const fetchProduct = async () => {
    await getProductList({
      company,
      take: 1000,
      productStatus: "ACTIVE",
      productBrandId: `${form.getFieldsValue(true).productBrandId}`,
    }).then((res) => {
      const findRound = dataForm.rounds.find((r) => r.roundNo === roundNo);
      const mapData = res.data.map((item) => ({
        ...item,
        isChecked:
          findRound?.products?.some((p) => `${p.productId}` === `${item.productId}`) ?? false,
        isEdit: findRound?.products?.some((p) => `${p.productId}` === `${item.productId}`)
          ? true
          : false,
        isDisabled:
          findRound?.products?.some((p) => `${p.productId}` === `${item.productId}`) ?? false,
        isSetting: findRound.products?.some((p) => `${p.productId}` === `${item.productId}`)
          ? (item.isSetting ?? false)
          : false,
        isNonQuota:
          findRound.products?.find((p) => `${p.productId}` === `${item.productId}`)?.isNonQuota ||
          false,
      }));
      formProduct.setFieldsValue({ productList: mapData, productSelect: mapData });
    });
  };

  useEffectOnce(() => {
    setLoading(true);
    fetchProduct();
    setTimeout(() => setLoading(false), 500);
  });

  const onSearch = (text: string, strategy: string, prodGroup: string) => {
    const filteredData = formProduct.getFieldValue("productList").filter((item) => {
      const textSearch = text ? item.productName.toLowerCase().includes(text.toLowerCase()) : true;
      const strategySearch = strategy
        ? company === "ICPL"
          ? item.productStrategy.toLowerCase().includes(strategy.toLowerCase())
          : item.productCategoryId === strategy
        : true;
      const prodGroupSearch = prodGroup ? item.productGroup === prodGroup : true;
      return textSearch && strategySearch && prodGroupSearch;
    });
    formProduct.setFieldsValue({ productSelect: filteredData });
  };

  const columns = [
    {
      title: (
        <Checkbox
          checked={formProduct?.getFieldValue("productSelect")?.every((x) => x.isChecked)}
          onClick={(e: any) => {
            const newSelectedProd = formProduct?.getFieldValue("productList").map((item) => {
              const dataSelect = formProduct
                .getFieldValue("productSelect")
                .find((ps) => item.productId === ps.productId);
              if (dataSelect) return { ...item, isChecked: e.target.checked };
              return item;
            });
            formProduct.setFieldsValue({ productList: newSelectedProd });
            onSearch(searchText, searchStrategy, searchProdGroup);
          }}
          disabled={
            formProduct?.getFieldValue("productSelect")?.every((x: any) => x.isDisabled) ?? false
          }
        />
      ),
      width: "5%",
      render: (text: string, value: any, index: any) => (
        <Checkbox
          checked={value.isChecked}
          onClick={(e: any) => {
            const newSelectedProd = formProduct
              .getFieldValue("productList")
              .map((item) =>
                item.productId === value.productId
                  ? { ...item, isChecked: e.target.checked }
                  : item,
              );
            formProduct.setFieldsValue({ productList: newSelectedProd });
            onSearch(searchText, searchStrategy, searchProdGroup);
          }}
          disabled={value.isDisabled}
        />
      ),
    },
    {
      title: <span>ชื่อสินค้า</span>,
      dataIndex: "productName",
      width: "40%",
      render: (text: string, value: any, index: any) => (
        <FlexRow align='center'>
          <div style={{ marginRight: 16 }}>
            <Avatar
              src={
                value?.productImage === "No" ||
                value?.productImage === "" ||
                value?.productImage === null
                  ? image.product_no_image
                  : value?.productImage
              }
              size={50}
              shape='square'
              onError={() => false}
            />
          </div>
          <FlexCol>
            <div style={{ height: 25, textOverflow: "ellipsis" }}>
              <Text level={5}>{value?.productName}</Text>
            </div>
            {value?.commonName && (
              <div style={{ height: 25, textOverflow: "ellipsis" }}>
                <Text level={6} style={{ color: color.Grey }}>
                  {value?.commonName}
                </Text>
              </div>
            )}
            <div style={{ height: 25 }}>
              <Text level={6} style={{ color: color.Grey }}>
                Product Group : {value?.productGroup}
              </Text>
            </div>
            {value?.productStrategy && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Strategy Group : {value?.productStrategy}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>Product Code</span>,
      dataIndex: "productCodeNAV",
      width: "20%",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25 }}>
              <Text level={5}>{text}</Text>
            </div>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={6} style={{ color: color.Grey }}>
                Pack Size : {value?.packSize}
              </Text>
            </div>
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>ราคาขาย</span>,
      dataIndex: "unitPrice",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={5}>
                {numberFormatter(value?.marketPrice)} บาท/{value?.saleUOMTH}
              </Text>
            </div>
            {company === "ICPL" && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Company : {value?.company}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>สถานที่</span>,
      dataIndex: "productLocation",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25 }}>
              <Text level={5}>{LOCATION_FULLNAME_MAPPING[text]}</Text>
            </div>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={6} style={{ color: color.Grey }}>
                ยี่ห้อ : {value?.productBrand?.productBrandName}
              </Text>
            </div>
          </FlexCol>
        </FlexRow>
      ),
    },
  ];

  return (
    <Modal
      maskClosable={false}
      open={open}
      centered={true}
      onCancel={() => onClose()}
      width={1350}
      title={
        <Text fontWeight={600} level={3}>
          เลือกสินค้าที่ต้องการ
        </Text>
      }
      footer={false}
      zIndex={300}
    >
      <Form layout='vertical' form={formProduct}>
        <Row gutter={16}>
          <Col span={9}>
            <Form.Item label='ค้นหาสินค้า'>
              <Input
                allowClear
                placeholder='ค้นหาชื่อสินค้าหรือรหัสสินค้า...'
                suffix={<SearchOutlined />}
                style={{ width: "100%", height: 40 }}
                onPressEnter={(e: any) => {
                  setSearchText(e.target.value);
                  onSearch(e.target.value, searchStrategy, searchProdGroup);
                }}
                onChange={(e) => {
                  if (!e.target.value) {
                    onSearch("", searchStrategy, searchProdGroup);
                  }
                  setSearchText(e.target.value);
                }}
                value={searchText}
              />
            </Form.Item>
          </Col>
          {company === "ICPL" && (
            <Col span={4}>
              <Form.Item label='Product Group'>
                <Select
                  data={[
                    {
                      key: "",
                      value: "",
                      label: "ทั้งหมด",
                    },
                    ...prodGroupList.map((p: any) => ({
                      key: p.product_group,
                      value: p.product_group,
                      label: p.product_group,
                    })),
                  ]}
                  onChange={(e) => {
                    setSearchProdGroup(e);
                    onSearch(searchText, searchStrategy, e);
                  }}
                  placeholder='Product Group'
                  style={{ width: "100%" }}
                  value={searchProdGroup}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={4}>
            <Form.Item label={company === "ICPL" ? "Strategy Group" : "Category Group"}>
              <Select
                data={[
                  {
                    key: "",
                    value: "",
                    label: "ทั้งหมด",
                  },
                  ...strategyGroupList.map((p: any) => ({
                    key: p.productCategoryId,
                    value: p.productCategoryId,
                    label: p.productCategoryName,
                  })),
                ]}
                onChange={(e) => {
                  setSearchStrategy(e);
                  onSearch(searchText, e, searchProdGroup);
                }}
                placeholder={company === "ICPL" ? "Strategy Group" : "Category Group"}
                style={{ width: "100%" }}
                value={searchStrategy}
              />
            </Form.Item>
          </Col>
          <Col span={3} style={{ paddingTop: "22px" }}>
            <Button
              title='ล้างการค้นหา'
              typeButton='primary-light'
              onClick={() => {
                setSearchText("");
                setSearchStrategy("");
                setSearchProdGroup("");
                onSearch("", "", "");
              }}
            />
          </Col>
        </Row>
        <Form.Item name='productSelect'>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  headerColor: "#FFFFFF",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                },
              },
            }}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={formProduct.getFieldValue("productSelect") || []}
              pagination={false}
              scroll={{ y: 360 }}
              style={{ height: 420 }}
            />
          </ConfigProvider>
        </Form.Item>
        <Divider style={{ margin: "12px 0px" }} />
        <Row justify='end'>
          <Button
            title='บันทึก'
            style={{ width: 136 }}
            onClick={() => {
              const find = formProduct
                .getFieldValue("productList")
                .filter((item: any) => item.isChecked && !item.isDisabled);
              find.length > 0 &&
                onSubmit(find.map((item: any) => ({ ...item, isChecked: false })) || []);
              onClose();
            }}
          />
        </Row>
      </Form>
    </Modal>
  );
};

const ModalSettingConditionProduct: React.FC<{
  typeSetting: "all" | "product";
  open: boolean;
  onClose: (key: string) => void;
  form: any;
  company: any;
  dataProduct: any;
  roundNo: any;
  optionPrice?: any;
}> = ({ typeSetting, open, onClose, form, company, dataProduct, roundNo, optionPrice }) => {
  const [formSetting] = Form.useForm();
  const [step, setStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState(
    dataProduct?.priceDisplay
      ? optionPrice.find((opt: any) => opt.key === dataProduct?.priceDisplay)
      : optionPrice[0],
  );

  const marketPrice = Form.useWatch("marketPrice", formSetting);
  const promotionOption = Form.useWatch("promotionOption", formSetting);
  const promotionType = Form.useWatch("promotionType", formSetting);
  const quotaType = Form.useWatch("quotaType", formSetting);

  const [oldData, setOldData] = useState<any>(null);

  const defaultForm = () => {
    formSetting.setFieldsValue({
      promotionOption: "true",
      promotionType: undefined,
      unit: dataProduct?.saleUOMTH || "หน่วย",
      discount: undefined,
      marketPrice: dataProduct?.marketPrice,
      priceAfterDiscount: undefined,
      quotaType: "QUOTA_TOTAL",
      quotaTotal: undefined,
      shopQuotaList: form.getFieldValue("shops"),
      searchShopQuotaList: form.getFieldValue("shops"),
      priceDisplay: selectedOption?.key,
      isEdit: true,
    });
  };

  useEffect(() => {
    if (dataProduct?.isSetting) {
      formSetting.setFieldsValue({
        promotionOption: dataProduct?.promotionType !== "NONE" ? "true" : "false",
        promotionType:
          dataProduct?.promotionType !== "NONE" ? dataProduct?.promotionType : undefined,
        discount: dataProduct?.discount,
        unit: dataProduct?.saleUOMTH || dataProduct?.saleUomTh,
        marketPrice: dataProduct?.marketPrice,
        quotaType: dataProduct?.quotaType,
        quotaTotal: dataProduct?.quotaTotal,
        searchShopQuotaList: form.getFieldValue("shops").map((shop: any) => {
          const shopQuota = dataProduct?.shopQuotas?.find(
            (sq: any) => `${sq.flashSaleShopId}` === `${shop.flashSaleShopId}`,
          );
          return {
            ...shop,
            quota: shopQuota?.quota,
          };
        }),
        shopQuotaList: form.getFieldValue("shops").map((shop: any) => {
          const shopQuota = dataProduct?.shopQuotas?.find(
            (sq: any) => `${sq.flashSaleShopId}` === `${shop.flashSaleShopId}`,
          );
          return {
            ...shop,
            quota: shopQuota?.quota,
          };
        }),
        priceDisplay: dataProduct?.priceDisplay,
        isEdit: false,
        sameQuota: dataProduct?.defaultQuotaPerShop || undefined,
      });
      setOldData(formSetting.getFieldsValue(true));
    } else {
      defaultForm();
      setOldData(formSetting.getFieldsValue(true));
    }
  }, [dataProduct]);

  const stepOne = () => {
    return (
      <div key={0}>
        <Text level={4} fontWeight={600}>
          โปรโมชัน
        </Text>
        <Row justify='space-between' gutter={16}>
          <Col span={24}>
            <Form.Item name='promotionOption'>
              <Radio.Group
                className='mode-radio-group'
                onChange={(e) => {
                  if (e.target.value === "false") {
                    formSetting.setFieldsValue({
                      promotionType: undefined,
                      discount: undefined,
                      unit: dataProduct?.saleUOMTH,
                      priceAfterDiscount: undefined,
                      marketPrice: dataProduct?.marketPrice,
                    });
                  }
                }}
              >
                <Radio value='true'>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      กำหนดโปรโมชันสินค้า
                    </Text>
                  </Flex>
                </Radio>
                <Radio value='false'>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      ไม่กำหนดโปรโมชันสินค้า
                    </Text>
                  </Flex>
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Divider size='small' />
        {promotionOption === "true" && (
          <Row justify='space-between' gutter={16}>
            <Col span={12}>
              <Form.Item
                label='ประเภทโปรโมชัน'
                name='promotionType'
                rules={[{ required: true, message: "กรุณาเลือกประเภทโปรโมชัน" }]}
              >
                <Select
                  allowClear={false}
                  placeholder='เลือกประเภทโปรโมชัน'
                  data={[
                    { label: "ส่วนลด บาท/หน่วย", value: "BAHT_PER_UNIT", key: "BAHT_PER_UNIT" },
                    { label: "ส่วนลด %/หน่วย", value: "PCT_PER_UNIT", key: "PCT_PER_UNIT" },
                  ]}
                  onChange={(value) => {
                    formSetting.validateFields(["discount"]);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {promotionType && (
          <Row justify='start' gutter={16}>
            <Col span={8}>
              <Form.Item
                label='ราคาที่ต้องการลด'
                name='discount'
                rules={[
                  { required: true, message: "กรุณาระบุส่วนลด" },
                  {
                    validator: (_, value) => {
                      if (value && promotionType === "BAHT_PER_UNIT" && value <= 0) {
                        return Promise.reject(new Error("ส่วนลดต้องมากกว่า 0 บาท"));
                      }
                      if (
                        value &&
                        promotionType === "BAHT_PER_UNIT" &&
                        Number(value) > Number(dataProduct?.marketPrice)
                      ) {
                        return Promise.reject(new Error("ส่วนลดต้องไม่เกินราคาขาย"));
                      }
                      if (
                        value &&
                        promotionType === "PCT_PER_UNIT" &&
                        (value <= 0 || value > 100)
                      ) {
                        return Promise.reject(new Error("ส่วนลดต้องไม่เท่ากับ 0 และไม่เกิน 100"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder='ระบุราคาส่วนลด'
                  suffix={promotionType === "BAHT_PER_UNIT" ? "บาท" : "%"}
                  style={{ height: "40px" }}
                  autoComplete='off'
                  onKeyDown={onInputNumberKeyPress}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label='ต่อหน่วย SKU' name='unit'>
                <Input style={{ height: "40px", color: color.BK }} disabled />
              </Form.Item>
            </Col>
            {typeSetting === "product" && (
              <>
                <Col span={5}>
                  <Form.Item label='ราคาหลังหักส่วนลด' shouldUpdate>
                    {() => {
                      const type = formSetting.getFieldValue("promotionType");
                      const marketPrice = formSetting.getFieldValue("marketPrice");
                      const discount = formSetting.getFieldValue("discount");
                      const unit = formSetting.getFieldValue("unit");
                      return (
                        <div style={{ paddingTop: "12px" }}>
                          <Text>
                            {marketPrice && discount
                              ? type === "BAHT_PER_UNIT"
                                ? `${numberFormatter(marketPrice - discount)} บาท/${unit}`
                                : type === "PCT_PER_UNIT"
                                  ? `${numberFormatter(marketPrice - (marketPrice * discount) / 100)} บาท/${unit}`
                                  : ""
                              : ""}
                          </Text>
                        </div>
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label='ราคาขายปกติ' shouldUpdate>
                    {() => {
                      const marketPrice = formSetting.getFieldValue("marketPrice");
                      const unit = formSetting.getFieldValue("unit");
                      return (
                        <div style={{ paddingTop: "12px" }}>
                          <Text>
                            {marketPrice ? `${numberFormatter(marketPrice)} บาท/${unit}` : ""}
                          </Text>
                        </div>
                      );
                    }}
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        )}
      </div>
    );
  };
  const stepTwo = () => {
    const dataForm = formSetting.getFieldsValue(true);

    return (
      <div key={1}>
        <FlexCol>
          <Text level={4} fontWeight={600}>
            รูปแบบโควตา
          </Text>
        </FlexCol>
        <Row>
          <Col span={24}>
            <Form.Item
              name='quotaType'
              rules={[{ required: true, message: "กรุณาเลือกประเภทโควตา" }]}
            >
              <Radio.Group className='mode-radio-group'>
                <Radio value='QUOTA_TOTAL'>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      โควตารวม
                    </Text>
                    <Text color='Text3' level={6}>
                      ทุกร้านค้าแย่งใช้โควตาเดียวกัน ใครสั่งก่อนได้ก่อน
                    </Text>
                  </Flex>
                </Radio>
                <Radio value='QUOTA_INDIVIDUAL'>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      โควตารายร้าน
                    </Text>
                    <Text color='Text3' level={6}>
                      แต่ละร้านได้รับจำนวนโควตาและสิทธิ์การใช้แยกกัน
                    </Text>
                  </Flex>
                </Radio>
                {dataForm.promotionOption === "true" && (
                  <Radio value='QUOTA_NONE'>
                    <Flex vertical>
                      <Text fontWeight={600} level={6}>
                        ไม่กำหนดโควตา
                      </Text>
                      <Text color='Text3' level={6}>
                        ทุกร้านสั่งซื้อสินค้าได้ แบบไม่จำกัดจำนวนโควตา
                      </Text>
                    </Flex>
                  </Radio>
                )}
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Divider size='small' />
        {quotaType === "QUOTA_TOTAL" && (
          <Row>
            <Col span={12}>
              <Form.Item
                label='จำนวนโควตารวม'
                name='quotaTotal'
                rules={[
                  { required: true, message: "กรุณาระบุจำนวนโควตารวม" },
                  {
                    validator: (_, value) => {
                      if (value && value <= 0) {
                        return Promise.reject(new Error("ส่วนลดต้องมากกว่า 0 บาท"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder='ระบุจำนวนโควตารวม'
                  suffix={dataForm.unit}
                  style={{ height: "40px" }}
                  autoComplete='off'
                  onKeyDown={onInputNumberKeyPress}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {quotaType === "QUOTA_INDIVIDUAL" && (
          <QuotaShopTable formQuota={formSetting} company={company} roundNo={roundNo} />
        )}
      </div>
    );
  };
  const stepThree = () => {
    return (
      <div key={2}>
        <FlexCol>
          <Text level={4} fontWeight={600}>
            แสดงราคาและสินค้า
          </Text>
          <Text color='Text3'>ช่วงเวลาก่อน Flash Sale เริ่มแต่ละรอบ</Text>
        </FlexCol>
        <br />
        <Row justify={"space-between"} gutter={16}>
          <Col span={18}>
            <Form.Item
              name='priceDisplay'
              rules={[{ required: true, message: "กรุณาเลือกตัวเลือก" }]}
            >
              <Radio.Group
                className='mode-radio-group'
                value={selectedOption.key}
                onChange={(e) => {
                  const find: any = optionPrice.find((option) => option.key === e.target.value);
                  setSelectedOption(find);
                }}
                style={{
                  marginBottom: "16px",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "12px 16px",
                }}
              >
                {optionPrice.map((option) => (
                  <Radio value={option.key} key={option.key}>
                    <Flex vertical>
                      <Text fontWeight={600} level={6}>
                        {option.name}
                      </Text>
                    </Flex>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={6}>
            <div
              style={{
                borderRadius: "8px",
                backgroundColor: "#EFF2F9",
                padding: "16px",
              }}
            >
              <Text fontWeight={600}>ตัวอย่างการแสดงผล</Text>
              <Card style={{ borderRadius: "20px" }} bodyStyle={{ padding: "10px" }}>
                <img src={selectedOption?.img} alt='empty sack' style={{ width: "100%" }} />
                {selectedOption?.key !== "SURPRISE" ? (
                  <>
                    <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                      <Text fontWeight={600} level={4}>
                        สินค้า
                      </Text>
                    </div>
                    <Row justify={"start"} style={{ marginTop: "8px", marginBottom: "8px" }}>
                      <Col>
                        <img
                          src={image.shipfree_tag}
                          alt='shipfree tag'
                          style={{ height: "25px" }}
                        />
                      </Col>
                      <Col>
                        <img
                          src={image.discount_tag}
                          alt='discount tag'
                          style={{ height: "25px" }}
                        />
                      </Col>
                    </Row>
                    <Text fontWeight={600} level={4}>
                      {selectedOption?.value} <Text color='Text3'>/หน่วย</Text>
                    </Text>
                    <br />
                    <Text delete color='Text3'>
                      11,200฿
                    </Text>
                  </>
                ) : (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <Text fontWeight={600} level={4}>
                      สินค้าเซอร์ไพรส์
                    </Text>
                    <br />
                    <Text color='Text3'>รอเปิดตัว</Text>
                  </div>
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const stepContent = [stepOne(), stepTwo(), stepThree()];

  const onNext = async () => {
    if (step === 0) {
      try {
        await formSetting.validateFields();
        setStep(step + 1);
      } catch (error) {
        console.error("step 1", error);
      }
    } else if (step === 1) {
      try {
        await formSetting.validateFields();
        const dataForm = formSetting.getFieldsValue(true);
        formSetting.setFieldsValue({
          searchShopQuotaList: dataForm.shopQuotaList,
        });
        setStep(step + 1);
      } catch (error) {
        console.error("step 2", error);
      }
    } else {
      try {
        await formSetting.validateFields();
      } catch (error) {
        console.error("step 2", error);
      }
    }
  };

  return (
    <Modal
      maskClosable={false}
      open={open}
      centered={true}
      onCancel={() => onClose("cancel")}
      width={1100}
      title={
        <>
          {typeSetting === "all" ? (
            <Text fontWeight={600} level={3}>
              ตั้งค่าเงื่อนไขเดียวกัน
            </Text>
          ) : (
            <>
              <Text fontWeight={600} level={3}>
                ตั้งค่าสินค้า Flash Sale
              </Text>
              <br />
              <Text fontWeight={400} color='Text3'>
                สินค้า : {dataProduct?.productName} • Pack Size : {dataProduct?.packSize}
              </Text>
            </>
          )}
        </>
      }
      footer={false}
    >
      <Divider size='small' />
      <Steps
        className='advance-credit-steps'
        current={step}
        items={[
          {
            title: "โปรโมชัน",
          },
          {
            title: "โควตา",
          },
          {
            title: "แสดงราคาและสินค้า",
          },
        ]}
      />
      <Divider size='small' />
      <Form
        form={formSetting}
        layout='vertical'
        initialValues={{ promotionOption: "true" }}
        onValuesChange={(changedValues, allValues) => {
          const changedKey = Object.keys(changedValues)[0];
          const isEdit = formSetting.getFieldValue("isEdit");
          if (changedValues[changedKey] !== oldData[changedKey] && !isEdit) {
            formSetting.setFieldValue("isEdit", true);
          } else {
            formSetting.setFieldValue("isEdit", isEdit);
          }
        }}
      >
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
          }}
        >
          {stepContent[step]}
        </div>
      </Form>
      <br />
      <Divider size='small' />
      <Row justify='space-between' gutter={12}>
        <Col span={10}>
          {step > 0 ? (
            <Button
              typeButton='primary-light'
              title='ย้อนกลับ'
              onClick={() => setStep(step - 1)}
              style={{ width: "18%" }}
            />
          ) : null}
        </Col>
        <Col span={3}>
          <Button
            typeButton='primary'
            title={step === 2 ? "บันทึก" : "ถัดไป"}
            onClick={async () => {
              if (step === 2) {
                const mainFormData = form.getFieldsValue(true);
                const dataSetting = formSetting.getFieldsValue(true);
                const newRounds = mainFormData.rounds.map((round: any, index: number) => {
                  if (`${round.roundNo}` === `${roundNo}`) {
                    const dataSelect =
                      typeSetting === "all"
                        ? round.products.filter((f) => f.isChecked)
                        : round.products.filter((f) => f.productId === dataProduct.productId);
                    const newProducts = round.products.map((product: any) => {
                      if (dataSelect.find((f: any) => f.productId === product.productId)) {
                        return {
                          ...product,
                          isSetting: true,
                          isEdit: dataSetting.isEdit,
                          isChecked: false,
                          isNonQuota: false,
                          promotionType:
                            dataSetting.promotionOption === "true"
                              ? dataSetting.promotionType
                              : "NONE",
                          discount: dataSetting.discount || undefined,
                          quotaType: dataSetting.quotaType,
                          quotaTotal:
                            dataSetting.quotaType === "QUOTA_NONE"
                              ? undefined
                              : dataSetting.quotaTotal,
                          defaultQuotaPerShop: dataSetting.sameQuota || undefined,
                          priceDisplay: dataSetting.priceDisplay,
                          shopQuotas:
                            dataSetting.quotaType === "QUOTA_INDIVIDUAL"
                              ? dataSetting.shopQuotaList.map((shop: any) => ({
                                  flashSaleShopId: shop.flashSaleShopId,
                                  quota: shop.quota,
                                }))
                              : [],
                        };
                      }
                      return product;
                    });
                    return {
                      ...round,
                      products: newProducts,
                      searchProducts: newProducts,
                    };
                  }
                  return round;
                });
                form.setFieldsValue({
                  ...mainFormData,
                  rounds: newRounds,
                });
                onClose("save");
              } else {
                onNext();
              }
            }}
          />
        </Col>
      </Row>
    </Modal>
  );
};

const QuotaShopTable: React.FC<{
  formQuota: any;
  company: any;
  roundNo: any;
}> = ({ formQuota, company, roundNo }) => {
  const dataForm = formQuota.getFieldsValue(true);
  const watchSearchShopQuotaList = Form.useWatch("searchShopQuotaList", formQuota);
  const [zoneList, setZoneList] = useState<any>([]);
  const [shopGroup, setShopGroup] = useState<any>({ count: 0, data: [] });
  const [sectionSearch, setSectionSearch] = useState<{
    searchZone: string | undefined;
    searchShopGroup: string | undefined;
    searchKeyWord: string | undefined;
  }>({
    searchZone: undefined,
    searchShopGroup: undefined,
    searchKeyWord: undefined,
  });
  const [modalSomeCondition, setModalSomeCondition] = useState(false);

  const fetchZone = async () => {
    const getZone = await getZones(company);
    setZoneList(getZone);
  };
  const fetchShopGroupList = async () => {
    await getShopGroup({
      company,
      take: 0,
      page: 0,
    }).then((res) => {
      setShopGroup({ count: res.responseData.count, data: res.responseData.data });
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchShopGroupList();
  });

  const onSearchShop = (keyWord?: string, zone?: string, shopGroup?: string) => {
    const shops = formQuota.getFieldValue("shopQuotaList");
    formQuota.setFieldValue(
      "searchShopQuotaList",
      shops.filter((shop: any) => {
        const matchZone = zone ? shop.zone === zone : true;
        const matchShopGroup = shopGroup ? shop.customerGroupName === shopGroup : true;
        const matchKeyWord = keyWord
          ? shop.customerName.includes(keyWord) || shop.customerNo.includes(keyWord)
          : true;
        return matchZone && matchShopGroup && matchKeyWord;
      }),
    );
  };

  const onSetQuotaSame = (value: number) => {
    const shops = formQuota.getFieldValue("shopQuotaList");
    const newShops = shops.map((shop: any) => ({ ...shop, quota: value }));
    formQuota.setFieldValue("shopQuotaList", newShops);
    formQuota.setFieldValue("searchShopQuotaList", newShops);
    formQuota.setFieldValue("defaultQuotaPerShop", value);
    onSearchShop(
      sectionSearch.searchKeyWord,
      sectionSearch.searchZone,
      sectionSearch.searchShopGroup,
    );
  };

  const columns = [
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3'>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จำนวนโควตา",
      dataIndex: "quota",
      key: "quota",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Form.Item
              name={["searchShopQuotaList", index, "quota"]}
              rules={[
                { required: true, message: "กรุณาระบุจำนวนโควตา" },
                {
                  validator: (_, value) => {
                    if (value && value <= 0) {
                      return Promise.reject(new Error("จำนวนโควตาต้องมากกว่า 0 บาท"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ height: "40px" }}
                suffix={dataForm?.unit || ""}
                autoComplete='off'
                placeholder='กรุณาระบุจำนวนโควตา'
                onKeyDown={onInputNumberKeyPress}
                onChange={(e) => {
                  const value = e.target.value;
                  const newShops = formQuota
                    .getFieldValue("shopQuotaList")
                    .map((shop: any, i: number) =>
                      shop.flashSaleShopId === row.flashSaleShopId
                        ? { ...shop, quota: value }
                        : shop,
                    );
                  formQuota.setFieldValue("shopQuotaList", newShops);
                }}
              />
            </Form.Item>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Form
        form={formQuota}
        layout='vertical'
        onValuesChange={(changedValues, allValues) => {
          const changedKey = Object.keys(changedValues)[0];
          const isEdit = formQuota.getFieldValue("isEdit");
          if (changedValues[changedKey] !== watchSearchShopQuotaList[changedKey] && !isEdit) {
            formQuota.setFieldValue("isEdit", true);
          } else {
            formQuota.setFieldValue("isEdit", isEdit);
          }
        }}
      >
        <Row justify={"start"} gutter={8} style={{ marginBottom: "10px" }}>
          <Col span={8}>
            <Input
              style={{ height: "40px" }}
              value={sectionSearch.searchKeyWord}
              placeholder='ค้นหาชื่อร้านค้า'
              suffix={<SearchOutlined />}
              allowClear
              onPressEnter={(e: any) =>
                onSearchShop(
                  e.target.value,
                  sectionSearch.searchZone,
                  sectionSearch.searchShopGroup,
                )
              }
              onChange={(e) => {
                if (!e.target.value) {
                  formQuota.setFieldValue(
                    "searchShopQuotaList",
                    formQuota.getFieldValue("shopQuotaList"),
                  );
                }
                setSectionSearch({
                  searchZone: sectionSearch.searchZone,
                  searchShopGroup: sectionSearch.searchShopGroup,
                  searchKeyWord: e.target.value,
                });
              }}
            />
          </Col>
          <Col span={3}>
            <Select
              value={sectionSearch.searchZone}
              data={
                zoneList?.map((zone) => ({
                  label: zone.zoneName,
                  value: zone.zoneName,
                  key: zone.zoneName,
                })) || []
              }
              placeholder='เลือกเขต'
              style={{ width: "100%" }}
              onChange={(e) => {
                setSectionSearch({
                  searchZone: e,
                  searchShopGroup: sectionSearch.searchShopGroup,
                  searchKeyWord: sectionSearch.searchKeyWord,
                });
                onSearchShop(sectionSearch.searchKeyWord, e, sectionSearch.searchShopGroup);
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              value={sectionSearch.searchShopGroup}
              data={
                shopGroup?.data?.map((group) => ({
                  label: group.customerGroupName,
                  value: group.customerGroupName,
                  key: group.customerGroupId,
                })) || []
              }
              placeholder='กลุ่มร้านค้า'
              style={{ width: "100%" }}
              onChange={(e) => {
                setSectionSearch({
                  searchZone: sectionSearch.searchZone,
                  searchShopGroup: e,
                  searchKeyWord: sectionSearch.searchKeyWord,
                });
                onSearchShop(sectionSearch.searchKeyWord, sectionSearch.searchZone, e);
              }}
            />
          </Col>
          <Col span={3}>
            <Button
              typeButton='primary-light'
              title='ล้างการค้นหา'
              onClick={() => {
                setSectionSearch({
                  searchZone: undefined,
                  searchShopGroup: undefined,
                  searchKeyWord: undefined,
                });
                formQuota.setFieldValue(
                  "searchShopQuotaList",
                  formQuota.getFieldValue("shopQuotaList"),
                );
              }}
            />
          </Col>
          <Col span={2} />
          <Col span={4}>
            <Button
              typeButton='primary-light'
              title='ตั้งค่าโควตาเดียวกัน'
              onClick={() => {
                setModalSomeCondition(true);
              }}
            />
          </Col>
        </Row>
        <Form.Item name='searchShopQuotaList'>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  headerColor: "#FFFFFF",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  //rowHoverBg: "none",
                },
              },
            }}
          >
            <Table
              size='small'
              columns={columns}
              dataSource={dataForm?.searchShopQuotaList || []}
              pagination={false}
            />
          </ConfigProvider>
        </Form.Item>
      </Form>
      {modalSomeCondition && (
        <Modal
          maskClosable={false}
          centered
          open={modalSomeCondition}
          onCancel={() => setModalSomeCondition(false)}
          cancelButtonProps={{ style: { display: "none" } }}
          okText='ยืนยัน'
          onOk={async () => {
            try {
              await formQuota.validateFields(["sameQuota"]);
              onSetQuotaSame(formQuota.getFieldValue("sameQuota"));
              setModalSomeCondition(false);
              formQuota.validateFields();
            } catch (error) {
              console.error(error);
            }
          }}
        >
          <Text fontWeight={600} level={4}>
            ตั้งค่าโควตาเดียวกัน
          </Text>
          <Form.Item
            label='จำนวนโควตาทุกร้าน'
            name='sameQuota'
            rules={[
              { required: true, message: "กรุณาระบุจำนวนโควตาทุกร้าน" },
              {
                validator: (_, value) => {
                  if (value && value <= 0) {
                    return Promise.reject(new Error("จำนวนโควตาต้องมากกว่า 0"));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder='ระบุจำนวนโควตาทุกร้าน'
              style={{ height: "40px" }}
              autoComplete='off'
            />
          </Form.Item>
        </Modal>
      )}
    </>
  );
};

const ModalDuplicateRound: React.FC<{
  open: boolean;
  onClose: (key: any) => void;
  form: any;
  roundNo: any;
}> = ({ open, onClose, form, roundNo }) => {
  const dataForm = form.getFieldsValue(true).rounds;
  const [optionRound, setOptionRound] = useState<any>([]);
  const [formDuplicateRound] = Form.useForm();

  useEffect(() => {
    const options = dataForm
      .filter((round: any, index: number) => round.roundNo !== roundNo && round.products.length > 0)
      .map((round: any, index: number) => ({
        label: `รอบที่ ${round.roundNo} (${dayjs(round.startDate).format("DD/MM/YYYY")} - ${dayjs(round.endDate).format("DD/MM/YYYY")})`,
        value: round.roundNo,
        key: round.roundNo,
      }));
    setOptionRound(options);
  }, [roundNo, dataForm]);

  const onSubmit = async () => {
    try {
      const values = await formDuplicateRound.validateFields();
      const duplicateRoundNo = values.duplicateRound;
      const duplicateRound = dataForm.find((round: any) => round.roundNo === duplicateRoundNo);

      if (duplicateRound) {
        const newRounds = dataForm.map((round: any) => {
          if (round.roundNo === roundNo) {
            const mapData = duplicateRound.products.map((product: any) => ({
              ...product,
              isChecked: false,
              isSetting: true,
              isEdit: true,
            }));
            return {
              ...round,
              products: mapData,
              searchProducts: mapData,
            };
          }
          return round;
        });
        form.setFieldsValue({
          rounds: newRounds,
        });
        onClose("save");
      }
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Modal
      maskClosable={false}
      open={open}
      centered
      onCancel={() => onClose("cancel")}
      width={500}
      title={
        <Text fontWeight={600} level={3}>
          ตั้งค่าสินค้าเดียวกันกับรอบอื่น
        </Text>
      }
      cancelButtonProps={{ style: { display: "none" } }}
      okText='บันทึก'
      onOk={onSubmit}
    >
      <Form form={formDuplicateRound} layout='vertical'>
        <Form.Item
          label='รอบเวลาที่ต้องการใช้สินค้าเดียวกัน'
          name='duplicateRound'
          rules={[{ required: true, message: "กรุณาเลือกช่วงเวลาที่ต้องการใช้สินค้าเดียวกัน" }]}
        >
          <Select
            placeholder='เลือกช่วงเวลาที่ต้องการใช้สินค้าเดียวกัน'
            data={optionRound}
            style={{ width: "100%" }}
          />
        </Form.Item>
        <br />
        <Alert
          description={`เมื่อบันทึกระบบจะคัดลอกสินค้าและการตั้งค่าทั้งหมดในรอบ ได้แก่ สินค้า, โปรโมชัน, โควตา, การแสดงราคาและสินค้า`}
          showIcon
          icon={<ExclamationCircleOutlined />}
          style={{
            padding: "10px",
            borderRadius: "8px",
            backgroundColor: "#F3F6F9",
            border: "none",
          }}
        />
        <Divider size='small' />
      </Form>
    </Modal>
  );
};
